import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import type { MainSmsAccountFindInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-find.dto';
import { MainSmsIntegrationTypeEnum } from '@zaoblako/shared/modules/integration/enums/main.sms.integration.type.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-newsletter-email-main-sms-sender-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './newsletter-email-main-sms-sender-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterEmailMainSmsSenderSingleSelectComponent implements OnChanges {
  @Input() public email = <MainSmsAccountFindInterface>{};
  @Output() public emailChange = new EventEmitter<MainSmsAccountFindInterface>();

  @Input() public emails: MainSmsAccountFindInterface[] = [];

  @Input() public styleClass: string;

  @Input() public showClear = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.emails?.currentValue) {
      this.emails = this.emails.filter((email) => email.type === MainSmsIntegrationTypeEnum.EMAIL);
    }
  }
}
